import { GenericExternalCommandType } from './generic-external-command';

export class GenericFilterParameter{
    filterType: string;
    titleBox: string;
    numFilteredTxt: string;
    emissioni: any[];
    activeFlow: any;
    externCommandsArray: GenericExternalCommandType[];
    externCommands: Map<string, GenericExternalCommandType>;
    dataArraySource: any[];
    writePermission: boolean;
    dettaglioView: boolean;

    constructor(){
        //console.log("GenericFilterParameter new class");
        this.filterType = "";
        this.titleBox = "title";
        this.numFilteredTxt = "Righe";
        this.emissioni = [];
        this.activeFlow = null;
        this.externCommandsArray = [];
        this.externCommands = new Map<string, GenericExternalCommandType>();
        this.dataArraySource = [];
        this.writePermission = false;
        this.dettaglioView = false;
    }

    mapToObject(m) {
        let o = {};
        //console.log("mapToObject map", m);
        m.forEach((value: GenericExternalCommandType, key: string) => {
            //console.log("mapToObject", key, value);
            if (value instanceof Map) {
                o[key] = this.mapToObject(value);
            }else {
                o[key] = value;
            }
        });
        //console.log("mapToObject result", o);
        return o;
    }

    setTypeFilter(filterType: string){
        this.filterType = filterType;
    }

    setTitleBox(titleBox: string){
        this.titleBox = titleBox;
    }

    setNumFilteredTxt(numFilteredTxt: string){
        this.numFilteredTxt = numFilteredTxt;
    }

    setDataArraySource(dataArraySource: any[]){
        this.dataArraySource = dataArraySource;
    }

    setEmissioni(emissioni: any[]){
        this.emissioni = emissioni;
    }

    setActiveFlow(activeFlow: any){
        this.activeFlow = activeFlow;
    }

    setExternCommands(externCommands: Map<string, GenericExternalCommandType>){
        this.externCommands = externCommands;
    }

    setWritePermission(writePermission: boolean){
        this.writePermission = writePermission;
    }

    setDettaglioView(dettaglioView: boolean){
        this.dettaglioView = dettaglioView;
    }

    generateParametriToString(){
        let thisLocal = {};
        Object.keys(this).forEach(
            (key) => {
                //console.log("generateParametriString", key, this[key]);
                if(key == 'externCommands'){
                    thisLocal[key] = this.mapToObject(this[key]);
                }else{
                    thisLocal[key] = this[key];
                }
            }
        );
        //console.log("generateParametriString thisLocal", this, thisLocal, JSON.stringify(thisLocal));
        return JSON.stringify(thisLocal);
    }

    generateParametriFromString(parametriString: string){
        let parsedParameter = JSON.parse(parametriString);
        Object.keys(parsedParameter).forEach((key) => {
            //console.log("generateParametriFromString key", key, parsedParameter[key]);
            switch(key){
                case 'filterType':
                    this.filterType = parsedParameter[key];
                    break;
                case 'titleBox':
                    this.titleBox = parsedParameter[key];
                    break;
                case 'numFilteredTxt':
                    this.numFilteredTxt = parsedParameter[key];
                    break;
                case 'emissioni':
                    this.emissioni = parsedParameter[key];
                    break;
                case 'activeFlow':
                    this.activeFlow = parsedParameter[key];
                    break;
                case 'externCommands':
                    this.externCommandsArray = [];
                    let externCommandsObj = parsedParameter[key];
                    Object.keys(externCommandsObj).forEach(key => {
                        this.externCommandsArray.push(externCommandsObj[key]);
                        this.externCommands.set(key, externCommandsObj[key]);
                    });
                    break;
                case 'dataArraySource':
                    this.dataArraySource = parsedParameter[key];
                    break;
                case 'writePermission':
                    this.writePermission = parsedParameter[key];
                    break;
                case 'dettaglioView':
                    this.dettaglioView = parsedParameter[key];
                    break;
                case 'externCommandsArray':
                    this.externCommandsArray = parsedParameter[key];
                    break;
                default:
                    console.log("key non trovato", key);
            }
        });
        return this;
    }
}
